'use strict';

module.exports.AppContainer = require('./AppContainer');